import { useEffect } from "react";
import { useLocation } from "wouter";

const APP_ID = "97b2e81b-257e-424d-8044-32f0be09f101";
const SDK_SRC = "https://clientcdn.pushengage.com/sdks/pushengage-web-sdk.js";
const EXCLUDED_PATHS = new Set(["/cms", "/privacy", "/terms", "/contact", "/404"]);

export function isPushEngageAllowed(pathname: string) {
  return !EXCLUDED_PATHS.has(pathname) && !pathname.startsWith("/cms/");
}

export default function PushEngageLoader() {
  const [location] = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || !isPushEngageAllowed(location)) return;
    let cancelled = false;
    const load = () => {
      if (cancelled) return;
      const existing = document.querySelector<HTMLScriptElement>(`script[src="${SDK_SRC}"]`);
      const win = window as Window & { PushEngage?: unknown[] | Record<string, unknown> };
      const current = win.PushEngage;
      if (Array.isArray(current)) {
        if (!current.some((item) => Array.isArray(item) && item[0] === "init")) {
          current.push(["init", { appId: APP_ID, disabledDefaultPrompt: true }]);
        }
      } else if (!current) {
        win.PushEngage = [["init", { appId: APP_ID, disabledDefaultPrompt: true }]];
      }
      if (!existing) {
        const script = document.createElement("script");
        script.src = SDK_SRC;
        script.async = true;
        script.type = "text/javascript";
        script.dataset.koraPushengage = "true";
        document.head.appendChild(script);
      }
    };
    const timer = window.setTimeout(load, 2500);
    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [location]);

  return null;
}
